import Header from "@/components/header";
import { CustomLink } from "@/styles/shared/link/link.style";
import { Card, Container, Menu, Stack, Text, Title } from "@mantine/core";
import {
  IconChartPie,
  IconChevronLeft,
  IconUsersGroup,
} from "@tabler/icons-react";

function Teams() {
  return (
    <>
      <Header
        title="مجموعه تیم"
        showBack
        route="/dashboard"
        bg="light-gray.0"
      />
      <Container w="100%" size="md" bg="light-gray.0">
        <Title order={4}>مجموعه تیم</Title>
        <Stack justify="start" flex={1} h="calc(100svh - 147px)">
          <Card withBorder mt="xl">
            <Menu>
              <CustomLink to="/dashboard/teams/teamMembers">
                <Menu.Item
                  leftSection={<IconUsersGroup size={20} stroke={1.5} />}
                  rightSection={<IconChevronLeft size={20} stroke={1} />}
                >
                  <Text fw={500}>مشاهده تیم</Text>
                </Menu.Item>
              </CustomLink>

              <CustomLink to="/dashboard/barber-overview">
                <Menu.Item
                  mt="xs"
                  leftSection={<IconChartPie size={20} stroke={1.5} />}
                  rightSection={<IconChevronLeft size={20} stroke={1} />}
                >
                  <Text fw={500}>آمار تیم</Text>
                </Menu.Item>
              </CustomLink>
            </Menu>
          </Card>
        </Stack>
      </Container>
    </>
  );
}

export default Teams;
